import { useTranslation } from 'react-i18next';

import { CompanyReadModel, usePutCompaniesByIdMutation } from '@client/api';
import { Skeleton } from '@client/toolkit';

import { CompanyForm, CompanyFormData } from '../../components';

interface CompanyEditModalProps {
  id: string;
  company?: CompanyReadModel;
  open: boolean;
  onClose: () => void;
  onAfterSubmit: () => void;
}

export function CompanyEditModal({ id, company, open, onClose, onAfterSubmit }: CompanyEditModalProps) {
  const { t: tGlobal, ready } = useTranslation('global');

  const [putCompany] = usePutCompaniesByIdMutation();

  const handleSubmit = async (data: CompanyFormData) => {
    await putCompany({
      id,
      body: { name: data.name ?? '', vatId: data.vatId ?? '', businessAddress: data.businessAddress ?? undefined },
    }).unwrap();

    onAfterSubmit();
  };

  return (
    <CompanyForm
      open={open}
      title={ready ? tGlobal('edit.company') : <Skeleton variant="text" />}
      onSubmit={handleSubmit}
      onClose={onClose}
      company={company}
    />
  );
}
